var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-date-picker",
    attrs: {
      owner: _vm._self,
      "block-class": { "ds-error-border": _vm.errors.length > 0 },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c("span", { attrs: { title: _vm.readOnlyText } }, [
                _vm._v(_vm._s(_vm.readOnlyText)),
              ]),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c("el-time-picker", {
                    attrs: {
                      disabled: _vm.disabled,
                      editable: false,
                      clearable: _vm.clearable,
                      "range-separator": _vm.rangeSeparator,
                      "value-format": _vm.valueFormat,
                      "arrow-control": _vm.arrowControl,
                      "start-placeholder": _vm.startPlaceholder,
                      "end-placeholder": _vm.endPlaceholder,
                      "is-range": "",
                      format: _vm.optionFormat,
                    },
                    on: { change: _vm.changeHandler },
                    model: {
                      value: _vm.timeValue,
                      callback: function ($$v) {
                        _vm.timeValue = $$v
                      },
                      expression: "timeValue",
                    },
                  })
                : _vm.readOnly
                ? _c("div", { staticClass: "ds-form-readonly" }, [
                    _c("span", { attrs: { title: _vm.readOnlyText } }, [
                      _vm._v(_vm._s(_vm.readOnlyText)),
                    ]),
                  ])
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }